"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var key_system_options_manager_1 = require("./drm/key-system-interaction/key-system-options-manager");
var browser_capabilities_1 = require("./browser-capabilities");
var browser_player_1 = require("./browser-player");
var browser_info_1 = require("./browser-info");
var browser_input_1 = require("./browser-input");
var browser_network_status_1 = require("./browser-network-status");
var widevine_key_system_options_generator_1 = require("./drm/widevine/widevine-key-system-options-generator");
var playready_key_system_options_generator_1 = require("./drm/playready/playready-key-system-options-generator");
var browser_lifecycle_1 = require("./browser-lifecycle");
var BrowserDeviceFactory = (function () {
    function BrowserDeviceFactory(context) {
        if (context === void 0) { context = window; }
        this.context = context;
        this.initialised = false;
    }
    BrowserDeviceFactory.prototype.identifiers = function () {
        return [client_lib_js_player_addons_common_player_1.DeviceType.Browser];
    };
    BrowserDeviceFactory.prototype.getInstance = function () {
        if (!this.initialised) {
            throw new Error('Browser Device Factory was not initialised');
        }
        return this.device;
    };
    BrowserDeviceFactory.prototype.initialise = function () {
        var _this = this;
        if (!this.initialisePromise) {
            var keySystemOptionsManager = new key_system_options_manager_1.default([
                playready_key_system_options_generator_1.createPlayreadyKeySystemOptionsGenerator(),
                widevine_key_system_options_generator_1.createWidevineKeySystemOptionsGenerator(),
            ]);
            var player_1 = new browser_player_1.BrowserPlayer(keySystemOptionsManager);
            var input_1 = new browser_input_1.BrowserInput(this.context);
            var capabilities_1 = new browser_capabilities_1.BrowserCapabilities();
            var storage_1 = new client_lib_js_player_addons_common_player_1.HTML5LocalStorage(this.context);
            var deviceInfo_1 = new browser_info_1.BrowserInfo(storage_1, this.context);
            var networkStatus_1 = new browser_network_status_1.BrowserNetworkStatus(this.context);
            var lifecycle_1 = new browser_lifecycle_1.BrowserLifecycle(player_1);
            this.initialisePromise = Promise.all([player_1.initialise(), deviceInfo_1.initialise()]).then(function () {
                _this.device = {
                    player: player_1,
                    input: input_1,
                    deviceInfo: deviceInfo_1,
                    capabilities: capabilities_1,
                    storage: storage_1,
                    networkStatus: networkStatus_1,
                    lifecycle: lifecycle_1,
                };
                _this.initialised = true;
            });
        }
        return this.initialisePromise;
    };
    return BrowserDeviceFactory;
}());
exports.BrowserDeviceFactory = BrowserDeviceFactory;
